import { render } from "./PartsVariousSourcesTable.vue?vue&type=template&id=046a87c4&scoped=true"
import script from "./PartsVariousSourcesTable.vue?vue&type=script&lang=js"
export * from "./PartsVariousSourcesTable.vue?vue&type=script&lang=js"

import "./PartsVariousSourcesTable.vue?vue&type=style&index=0&id=046a87c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046a87c4"]])

export default __exports__